define('lq/frontendModules',['lq'], function (lq) {
    'use strict';

    var createScript = function (scriptUrl) {
        var script = document.createElement('script');
        script.async = false; // make sure the script are executed in the correct order
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', scriptUrl);
        return script;
    };

    var createLink = function (linkUrl) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', linkUrl);
        return link;
    };

    var vendorLoaded = false;
    
    // cache the promises to avoid loading the same bundle multiple times
    var bundlePromisesCache = new Map();

    var load = function (bundleName, includeCss) {
        var serverTicks = lq.getScriptCacheBust();

        if (!vendorLoaded) {
            var script = createScript(lq.getFrontEndUrl('') + 'vendor.bundle.js?bust=' + serverTicks);
            document.getElementsByTagName('head')[0].appendChild(script);
            vendorLoaded = true;
        }

        if (bundlePromisesCache.has(bundleName)) {
            return bundlePromisesCache.get(bundleName);
        }

        if (includeCss) {
            var link = createLink(lq.getFrontEndUrl('') + bundleName + '.bundle.css?bust=' + serverTicks);
            document.getElementsByTagName('head')[0].appendChild(link);
        }

        var promise = new Promise((resolve) => {
            var script = createScript(lq.getFrontEndUrl('') + bundleName + '.bundle.js?bust=' + serverTicks);
            script.onload = function () {
                resolve(window[bundleName]);
            };
            document.getElementsByTagName('head')[0].appendChild(script);
        });

        bundlePromisesCache.set(bundleName, promise);
        
        return promise;
    };

    return {
        load: load
    };
});
